exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\r\n    max-height: 60vh;\r\n    overflow-y: auto;\r\n}\r\n\r\n.form-control:disabled, .form-control[readonly] {\r\n    padding-left: 1%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/vimeo/prava-pristupa/prava-pristupa.component.css
// module id = ../../../../../src/app/pages/vimeo/prava-pristupa/prava-pristupa.component.css
// module chunks = main